import { ReactElement } from 'react'

import isEmpty from 'lodash/isEmpty'
import queryString from 'query-string'
import { Link } from 'react-router-dom'

import { UNDEFINED_VALUE } from 'const/formatting'
import { userHasDashboardsOnlyPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions } from 'hooks'
import { campaignUrl } from 'routing/urls'
import { Campaign } from 'types'

interface CampaignLinkProps {
    campaign?: Campaign | null
    queryParams?: object
}

const CampaignLink = ({
    campaign = null,
    queryParams = {},
}: CampaignLinkProps): ReactElement => {
    const dashboardOnlyExperience = useUserHasPermissions(
        userHasDashboardsOnlyPermissions
    )

    if (!campaign || isEmpty(campaign)) {
        return <span>{UNDEFINED_VALUE}</span>
    }

    const pathname = campaignUrl(campaign.id)
    const search = queryString.stringify(queryParams)

    return dashboardOnlyExperience ? (
        <span>{campaign.name}</span>
    ) : (
        <Link
            to={{ pathname, search }}
            title={campaign.name}
            className="campaign-link"
        >
            {campaign.name}
        </Link>
    )
}

export default CampaignLink
